<template>
  <!-- Trigger -->
  <div @mouseover="hover = true" @mouseleave="hover = false">
      <slot></slot>
  </div>
  <!-- ToolTip -->
  <div v-if="hover" class="tooltip bg-tooltip" :style="toolTipPos">
    <slot name="tooltip"></slot>
  </div>
</template>


<script setup>
import { ref, computed } from 'vue'
import { useMouse } from '@vueuse/core'
const { x, y } = useMouse()

const toolTipPos = computed(() => {
  return [
    {"left" : x.value +"px"},
    {"top" : y.value +20 +"px"},
  ]
})

const hover = ref(false)

</script>

<style scoped>
.tooltip {
  position: fixed;
  z-index: 10;
  min-height: 0.5rem;
  min-width: 0.5rem;
}
</style>